export enum SIDEBAR_VARIANTS {
  TEMPORARY = 'temporary',
  PERSISTENT = 'persistent',
  PERMANENT = 'permanent',
}

export enum SIDEBAR_STYLES {
  FULL_HEIGHT = 'full-height',
  CLIPPED_UNDER_HEADER = 'clipped-under-header',
}

export enum SIDEBAR_SCROLL_TYPES {
  DEFAULT = 'default',
  FIXED = 'fixed',
}

export enum SIDEBAR_ANCHOR_POSITIONS {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',
}

export enum LAYOUT_DENSITIES {
  STANDARD = 'standard',
  COMPACT = 'compact',
  COMFORTABLE = 'comfortable',
}

export enum LAYOUT_CONTAINER_STYLES {
  FLUID = 'fluid',
  BOXED = 'boxed',
}

export enum POSITION_TYPES {
  STICKY = 'sticky',
  DEFAULT = 'default',
}

export enum SIDEBAR_VIEWS {
  MINI = 'mini',
  FULL = 'full',
}

export enum LAYOUT_ACTIONS {
  SET_SIDEBAR_OPTIONS = 'set-sidebar-options',
  SET_HEADER_OPTIONS = 'set-header-options',
  SET_FOOTER_OPTIONS = 'set-footer-options',
  SET_OPTIONS = 'set-options',
  SET_ROOT_OPTIONS = 'set-root-options',
  SET_CONTENT_OPTIONS = 'set-content-options',
  SET_WRAPPER_OPTIONS = 'set-wrapper-options',
  SET_MAIN_OPTIONS = 'set-main-options',
}
